module.exports = __webpack_public_path__ + "media/images/icons/file-icon-178e516622c2b3846ad8af65fc0e356c.svg";